// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import quickBooksApi from '~/apis/quickBooks';
import {
  GET_LIST_CUSTOMER_QUICK_BOOKS,
  GET_AUTH_URL_QUICK_BOOKS,
  DISCONNECT_QUICK_BOOKS,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';

export const getListCustomerQuickBooks = createAsyncThunk(
  GET_LIST_CUSTOMER_QUICK_BOOKS,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await quickBooksApi.getListCustomerQuickBooks(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAuthUrlQuickBooks = createAsyncThunk(GET_AUTH_URL_QUICK_BOOKS, async () => {
  try {
    const res = await quickBooksApi.getAuthUrl();
    return res.data.data;
  } catch (error) {
    throw error;
  }
});

export const disconnectQuickBooks = createAsyncThunk(DISCONNECT_QUICK_BOOKS, async () => {
  try {
    const res = await quickBooksApi.disconnect();
    return res.data;
  } catch (error) {
    throw error;
  }
});
